import { Injectable } from '@angular/core';

@Injectable()
export class Curso
{
  public id: number = 0;
  public titulo: string = '';
  public descripcion: string = '';
  public autor: string = '';
  public categoria_id: number = -1;
  public link: string = '';
  public lecciones: number = 0;
  public imagen: string = '';
  public estado: boolean = true;

  constructor() 
  { 
  }

  limpiarVariables()
  {
    this.id = 0;
    this.titulo = '';
    this.descripcion = '';
    this.autor = '';
    this.categoria_id = -1;
    this.link = '';
    this.lecciones = 0;
    this.estado = true;
  }
}
